import React from "react";
import { X, Download } from "lucide-react";

/**
 * iter-169j — Print preview lightbox for flattened schedules.
 *
 * Renders the flattened PDF (returned by `POST /uploads/:id/schedule-flatten`)
 * inside an iframe so the user can eyeball every value before printing
 * or downloading. Uses a blob URL (revoked when the dialog closes) so
 * the raw PDF bytes never leave the client after preview.
 */
export default function PrintPreviewDialog({ open, blobUrl, filename, onDownload, onOpenChange }) {
    if (!open || !blobUrl) return null;
    return (
        <div
            data-testid="print-preview-dialog"
            className="fixed inset-0 z-[125] bg-black/70 flex items-center justify-center p-4"
            onClick={(e) => { if (e.target === e.currentTarget) onOpenChange(false); }}
        >
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-[90vh] flex flex-col overflow-hidden">
                <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
                    <div>
                        <div className="text-sm font-bold text-slate-900">Print preview</div>
                        <div className="text-xs text-slate-500">Fully flattened — every field is baked in.</div>
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            data-testid="btn-print-preview-download"
                            onClick={onDownload}
                            className="inline-flex items-center gap-2 px-3 py-2 rounded bg-[#007AFF] text-white text-sm font-semibold hover:bg-[#0066CC]"
                        >
                            <Download className="w-4 h-4" />
                            Download
                        </button>
                        <button
                            data-testid="btn-close-print-preview"
                            onClick={() => onOpenChange(false)}
                            className="p-2 rounded hover:bg-slate-100"
                        >
                            <X className="w-4 h-4 text-slate-600" />
                        </button>
                    </div>
                </div>
                <iframe
                    title={filename || "Print preview"}
                    data-testid="print-preview-iframe"
                    src={blobUrl}
                    className="flex-1 w-full"
                />
            </div>
        </div>
    );
}
